export class Categoria {
  uid: string;
  descrizione: string;
  image:string;
}
